export default __webpack_public_path__ + "static/media/Medium.961de2d8.woff2";